const PUESTO_DEFAULT = 'POLICIA'
const INSTITUCION_DEFAULT = 'Secretaría de Seguridad Ciudadana'

export default class AcademicPerformanceEvaluation {
  idPersonal
  idPersonalEvaluador
  idMunicipio
  fechaInicio
  fechaFin
  fechaAplicacion
  institucionSeguridadAspirada
  puestoAspirado

  constructor(idPersonal) {
    this.idPersonal = idPersonal
    this.idPersonalEvaluador = null
    this.idMunicipio = null
    this.fechaInicio = null
    this.fechaFin = null
    this.fechaAplicacion = null
    this.institucionSeguridadAspirada = INSTITUCION_DEFAULT
    this.puestoAspirado = PUESTO_DEFAULT
  }
}
